export const SELL_OPERATION = "بيع";
export const BUY_OPERATION = "شراء";
export const WAITING_FOR_SHIPPING = "منتظر الشحن";
export const WAITING_FOR_SHIPPING_STATUS_DESCRIPTION_SELLER =
  "قم بتوصيل المنتج الي المشتري في الوقت المحدد";
export const WAITING_FOR_SHIPPING_STATUS_DESCRIPTION_BUYER =
  "يقوم البائع بتوصيل المنتج اليك";
export const WAITING_FOR_INSPECTION = "جاري الفحص";
export const WAITING_FOR_INSPECTION_STATUS_DESCRIPTION_SELLER =
  "يقوم المشتري بفحص المنتج";
export const WAITING_FOR_INSPECTION_STATUS_DESCRIPTION_BUYER =
  "لديك ٤٨ ساعة لفحص المنتج";
export const ESCALATION_STATUS = "جاري التحكيم";
export const ESCALATION_STATUS_DESCRIPTION_SELLER =
  "قام المشتري بتصعيد المعامله لوفي";
export const ESCALATION_STATUS_DESCRIPTION_BUYER =
  "سيقوم خبراء وفّي بمراجعة المشاكل والتوصل لحل";
export const ACTIVE_STATUS = "نشط";
export const ACTIVE_STATUS_DESCRIPTION_SELLER = "قم بمشاركة الرابط مع المشتري";
export const ACTIVE_STATUS_DESCRIPTION_BUYER = "يمكنك دفع قيمة الخدمة";

export const COMPLETED_STATUS = "عملية ناجحة";
export const COMPLETED_STATUS_DESCRIPTIONـSELLER =
  "تم تحويل قيمة المعاملة لحسابك بنجاح";
export const COMPLETED_STATUS_DESCRIPTIONـBUYER =
  "تم تحويل قيمة المعاملة للبائع بنجاح";

export const CANCELLED_STATUS = "عملية ملغية";
export const REQUIRED_AMOUNT = "المبلغ المطلوب";

export const ITEM_ACCEPTED_STATUS = "تمت العملية بنجاح";
export const ITEM_ACCEPTED_STATUS_BUYER_DESCRIPTION =
  "سنقوم بتحويل قيمة المعاملة للبائع";
export const ITEM_ACCEPTED_STATUS_SELLER_DESCRIPTION =
  "سنقوم بتحويل قيمة المعاملة لحسابك";

export const RESOLVED_STATUS = "تم حل المشلكة";
export const RESOLVE_BUYER_REFUND_STATUS_SELLER_DESCRIPTION =
  "سنقوم برد المعاملة للمشتري";
export const RESOLVE_BUYER_REFUND_STATUS_BUYER_DESCRIPTION =
  "سنقوم برد قيمة المعاملة لحسابك";

export const RESOLVE_SELLER_REALSE_STATUS_BUYER_DESCRIPTION =
  "سنقوم بتحويل قيمة المعاملة للبائع";
export const RESOLVE_SELLER_REALSE_STATUS_SELLER_DESCRIPTION =
  "سنقوم بتحويل قيمة المعاملة لحسابك";

export const CLOSED_STATUS = "انتهت المعاملة";
export const CLOSED_RELEASE_PROVIDER_DESCRIPTION =
  "قمنا بتحويل قيمة المعاملة لحسابك";
export const CLOSED_RELEASE_BUYER_DESCRIPTION =
  "قمنا بتحويل قيمة المعاملة للبائع";
export const CLOSED_REFUND_SELLER_DESCRIPTION =
  "قمنا برد قيمة المعاملة للمشتري";
export const CLOSED_REFUND_CUSTOMER_DESCRIPTION =
  "قمنا برد قيمة المعاملة لحسابك";
